import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { staffApi } from '../../services/staffApi';

/**
 * Admins who enrolled before recovery codes existed have none. Until they
 * create a set, losing their phone means waiting for another admin — so the
 * shell nags, once per page load, until they do.
 */
export function RecoveryCodesNudge() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let alive = true;
    staffApi.security.mine()
      .then((s) => { if (alive) setShow(s.authenticatorEnabled && s.recoveryCodesRemaining === 0); })
      .catch(() => { /* never block the panel on this */ });
    return () => { alive = false; };
  }, []);

  if (!show) return null;
  return (
    <div className="mb-3 p-3 rounded-lg bg-amber-50 border border-amber-300 text-amber-900 text-sm flex flex-wrap items-center gap-3">
      <AlertTriangle size={18} className="shrink-0" />
      <span className="flex-1 min-w-[200px]">
        You have no recovery codes. If you lose your phone you will need another super admin to let you back in.
      </span>
      <button
        type="button"
        onClick={() => navigate('/my-security')}
        className="min-h-[44px] px-4 rounded-lg bg-[#DC143C] hover:bg-[#9F1239] text-white font-medium"
      >
        Create recovery codes
      </button>
    </div>
  );
}
